import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "../../style/index.css";
import * as userActions from "../../../../actionCreators/User";
import { Typography, Tabs, Button, Row, Col, notification } from "antd";
import { useParams, useHistory } from "react-router-dom";
import Profile from "./Profile";
import ChangePassword from "./ChangePassword";
import "./style/accountSettings.css";
import ProfileAdmin from "./ProfileAdmin";

const { TabPane } = Tabs;

function AccountSettings({
  updatePassword,
  updatePhoneAndAddress,
  error,
  passwordError,
  successMessage,
  buttonLoading,
  isAdmin,
}) {
  const history = useHistory();
  const { id } = useParams();
  const [updateDisabled, setUpdateDisabled] = useState(true);
  const [phone, setPhone] = useState(null);
  const [address, setAddress] = useState(null);
  const [passwordObj, setPasswordObj] = useState(null);
  const [responsePasswordError, setResponsePasswordError] = useState(null);
  const [activeTab, setActiveTab] = useState(id);
  function tabChange(key) {
    setActiveTab(key);
    history.push("/account-settings/" + key);
    setUpdateDisabled(true);
    if (key === "profile") {
      setPasswordObj(null);
    } else if (key === "change-password") {
      setPhone(null);
      setAddress(null);
    }
  }
  const updateDetails = () => {
    if (phone !== null || address !== null) {
      if (phone !== null && address !== null) {
        updatePhoneAndAddress({ phone, address });
      } else if (phone !== null) {
        updatePhoneAndAddress({ phone });
      } else if (address !== null) {
        updatePhoneAndAddress({ address });
      }
    } else if (passwordObj) {
      const {
        newPassword,
        oldPassword,
        oldPasswordIncluded,
        logout_all_devices,
      } = passwordObj;
      updatePassword({
        newPassword,
        oldPasswordIncluded,
        oldPassword,
        logout_all_devices,
      });
    }
  };
  useEffect(() => {
    if (error) {
      notification.error({
        message: error,
      });
    }
  }, [error]);
  useEffect(() => {
    if (passwordError) {
      setResponsePasswordError(passwordError);
    }
  }, [passwordError]);
  useEffect(() => {
    if (successMessage) {
      notification.success({
        message: successMessage,
      });
      window.location.reload();
    }
  }, [successMessage]);
  return (
    <>
      <Row>
        <Col span={20}>
          <Typography className="heading">Account Settings</Typography>
        </Col>
        <Col
          span={4}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            onClick={updateDetails}
            disabled={updateDisabled}
            loading={buttonLoading}
            className={
              updateDisabled ? "update-button-disabled" : "update-button"
            }
          >
            UPDATE
          </Button>
        </Col>
      </Row>
      <Tabs
        activeKey={activeTab}
        defaultActiveKey={id}
        onChange={tabChange}
        destroyInactiveTabPane
        className="tab-main"
      >
        <TabPane tab="PROFILE" key="profile" className="tab-pane">
          {!isAdmin && (
            <Profile
              updatePhone={(data) => setPhone(data)}
              updateAddress={(data) => setAddress(data)}
              toggleUpdateDisability={(data) => setUpdateDisabled(data)}
            />
          )}
          {isAdmin && (
            <ProfileAdmin
              updatePhone={(data) => setPhone(data)}
              updateAddress={(data) => setAddress(data)}
              toggleUpdateDisability={(data) => setUpdateDisabled(data)}
            />
          )}
        </TabPane>
        <TabPane
          tab="CHANGE PASSWORD"
          key="change-password"
          className="tab-pane"
        >
          <ChangePassword
            passwordError={responsePasswordError}
            updatePasswordObj={(data) => setPasswordObj(data)}
            toggleUpdateDisability={(data) => setUpdateDisabled(data)}
          />
        </TabPane>
      </Tabs>
    </>
  );
}

const mapStateToProps = ({
  user: {
    successMessage,
    currentUser: { error, passwordError, buttonLoading },
  },
}) => ({ error, passwordError, successMessage, buttonLoading });

const mapDispatchToProps = (dispatch) => ({
  updatePassword: bindActionCreators(userActions.updatePassword, dispatch),
  updatePhoneAndAddress: bindActionCreators(
    userActions.updatePhoneAndAddress,
    dispatch
  ),
});

AccountSettings.propTypes = {
  user: PropTypes.object,
  updatePassword: PropTypes.func.isRequired,
  updatePhoneAndAddress: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);
